import { useTranslation } from 'react-i18next'
import { LoadingSpinner } from '@honestica/curecall-ui'
import { isNotFoundError } from 'src/utils/http-error.util'
import { MissingDocumentFileBadge } from 'src/components/patient/missing-document-file-badge.component'
import { TPatientFollowupDocument } from 'src/pages/patients/patient-file/patient-followup/_components/patient-forms/use-patient-followup-documents.hook'
import { usePatientFollowupDocumentFile } from 'src/pages/patients/patient-file/patient-followup/_components/patient-forms/use-patient-followup-document-file.hook'

interface DocumentPreviewProps {
  document: TPatientFollowupDocument
  name: string
  patientId: string | number
  projectId: string | number
}

const DocumentPreview = ({ document, name, patientId, projectId }: DocumentPreviewProps) => {
  const { t } = useTranslation()
  const { objectUrl, mimeType, isLoading, isError, error, refetch } = usePatientFollowupDocumentFile(
    document,
    patientId,
    projectId,
  )

  if (isLoading) {
    return (
      <div className="c-flex c-justify-center c-py-8">
        <LoadingSpinner />
      </div>
    )
  }

  if (isError && isNotFoundError(error)) {
    return <MissingDocumentFileBadge />
  }

  if (isError || !objectUrl) {
    return (
      <div className="c-flex c-items-center c-gap-3 c-text-sm c-text-red-700">
        <span>{t('components.patient-documents-drawer.preview-error')}</span>
        <button type="button" onClick={() => refetch()} className="c-font-medium c-underline">
          {t('components.patient-documents-modal.retry')}
        </button>
      </div>
    )
  }

  if (mimeType.startsWith('image/')) {
    return <img src={objectUrl} alt={name} className="c-mx-auto c-max-w-full" />
  }

  return (
    <iframe
      src={objectUrl}
      title={name}
      className="c-h-full c-min-h-[600px] c-w-full c-border-0 c-bg-white"
    />
  )
}

export { DocumentPreview }
